export default __webpack_public_path__ + "static/media/VectorBlue.59b7d6f8.svg";